import React from "react";
import { Sparkles, Bot } from "lucide-react";

const ENGINES = [
  { id: "gemini", label: "Gemini", icon: Sparkles },
  { id: "chatgpt", label: "ChatGPT", icon: Bot },
];

export const AiEngineToggle = ({ value, onChange }) => (
  <div className="inline-flex rounded-full bg-sand border border-border p-1" data-testid="ai-engine-toggle">
    {ENGINES.map((e) => {
      const active = value === e.id;
      return (
        <button
          key={e.id}
          type="button"
          onClick={() => onChange(e.id)}
          className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-sm font-bold transition-colors ${
            active ? "bg-clay text-white" : "text-ink/60 hover:text-ink"
          }`}
          data-testid={`ai-engine-${e.id}`}
        >
          <e.icon size={14} /> {e.label}
        </button>
      );
    })}
  </div>
);
